module.exports = __webpack_public_path__ + "static/img/iconfont.599fa98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont.svg?t=1537345898601
// module id = lP8Q
// module chunks = 90